import { render, staticRenderFns } from "./ShiftWorkDetail.vue?vue&type=template&id=30070595"
import script from "./ShiftWorkDetail.vue?vue&type=script&lang=ts"
export * from "./ShiftWorkDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports